import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';
import { useDataContext } from '../DataContext';

function MortgageInformation() {

  const { updateMortgageInformation } = useDataContext();

  document.title = "SimWealth";

  const [formData, setFormData] = useState({
    loanLTV: 80,
    loanInterestRate: 4.5,
    periodInYears: 30,
    loanType: "AMORTIZED",
  });

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    updateMortgageInformation({ formData });
  };

  useEffect(() => {
    updateMortgageInformation({ formData });
  }, [formData]);

  return (
    <>
      <div className="bg bg-num-of-rental-property">
      <div data-aos="fade-right" className="container-fluid row vh-100 w-100">
            <div className=" col-12 col-sm-12 col-md-8 d-flex justify-content-center align-items-start my-auto text-center  ">
                <div className="bg-white rounded-border ms-3 p-4 border border-4 border-dark">
              <p className="mb-5">
              Enter Sam’s mortgage information below to simulate.<br />
                <small>(if you want to simulate all cash, enter 0 for “Loan LTV”)</small>
              </p>
              <div className="row  mx-5 ">
              <div className="d-flex mb-3 justify-content-end align-items-end ">
                  <label className="fs-18 me-4">Loan LTV</label>
                  <CurrencyInput
                    id="loanLTV"
                    name="loanLTV"
                    className="rounded"
                    placeholder="Loan LTV%"
                    suffix="%"
                    title="Valid range is 0% to 80%"
                    value={formData.loanLTV}
                    onValueChange={(value, name) => handleChange(value, name)}
                  />                    
                </div>
                <div className="d-flex mb-3 justify-content-end align-items-end">
                  <label className="fs-18 me-4">Loan Interest Rate</label>
                  <CurrencyInput
                    id="loanInterestRate"
                    name="loanInterestRate"
                    className="rounded"
                    placeholder="Loan Interest Rate%"
                    suffix="%"
                    title="Valid range is 2% to 6%"
                    value={formData.loanInterestRate}
                    onValueChange={(value, name) => handleChange(value, name)}
                  />
                </div>
                <div className="d-flex mb-3 justify-content-end align-items-end">
                  <label className="fs-18 me-4 text-nowrap">Period in Years</label>
                  <select className="form-select w-unset border-1 rounded border border-dark" 
                  style={{width:"245px!important"}}
                  value={formData.periodInYears}
                  name="periodInYears"
                  onChange={(e) => handleChange(parseInt(e.target.value), 'periodInYears')}
                  >
                        <option value={15}>15</option>
                        <option value={30}>30</option>
                    </select>
                </div>
                <div className="d-flex mb-3 justify-content-end align-items-end">
                  <label className="fs-18 me-4 text-nowrap">Loan Type</label>
                  <select className=" form-select w-unset border-1 rounded border border-dark"
                  name="loanType"
                  style={{width:"245px!important"}}
                  value={formData.loanType}
                  onChange={(e) => handleChange(e.target.value, 'loanType')}
                  >
                        <option value={"AMORTIZED"}>AMORTIZED</option>
                        <option value={"INTEREST-ONLY"}>INTEREST-ONLY</option>
                    </select>
                </div>
              </div>
              <Link to={'/personalize-simulation/personalize-simulation-decision-making'} 
                    className="threeDButton btn fw-bold  w-50 mt-5">
                    Continue
                </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MortgageInformation;
